import { FIELD_LABELS as pgrc1to6_2023_07Labels } from "../reports/progress-gr1-6-2023-07/fieldLabels";
import { FIELD_LABELS as pvrc1to6_2023_09Labels } from "../reports/provincial-gr1-6-2023-09/fieldLabels";

export const REPORT_FIELD_LABELS = {
  pgrc1to6_2023_07: pgrc1to6_2023_07Labels,
  pvrc1to6_2023_09: pvrc1to6_2023_09Labels,
};
